module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-reporting"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('fieldset', {
    staticClass: "large-2 columns"
  }, [_c('label', [_vm._v("Status")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.status),
      expression: "body.status"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PENDING_REVIEW"
    }
  }, [_vm._v("Pending Review")]), _c('option', {
    attrs: {
      "value": "CONFIRMED"
    }
  }, [_vm._v("Confirmed")]), _c('option', {
    attrs: {
      "value": "RESOLVED"
    }
  }, [_vm._v("Resolved")]), _c('option', {
    attrs: {
      "value": "VOIDED"
    }
  }, [_vm._v("Voided")])])]), _c('fieldset', {
    staticClass: "large-3 columns"
  }, [_c('label', [_vm._v("Vehicle")]), _c('selectize-vehicle', {
    attrs: {
      "max-items": 1,
      "selectedValue": _vm.body.vehicle_id
    },
    on: {
      "optionSelected": _vm.vehicleSelected
    }
  })], 1), _c('fieldset', {
    staticClass: "large-3 columns"
  }, [_c('label', [_vm._v("Type")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.reporting_type_id),
      expression: "body.reporting_type_id"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "reporting_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.isDamageReport]
    }
  }, _vm._l((_vm.reportingTypes), function(type) {
    return _c('option', {
      domProps: {
        "value": type.id
      }
    }, [_vm._v(_vm._s(type.name))])
  }), 0)]), _c('fieldset', {
    staticClass: "large-3 columns"
  }, [_c('label', [_vm._v("Driver")]), _c('selectize-driver', {
    attrs: {
      "max-items": 1
    },
    on: {
      "optionSelected": _vm.driverSelected
    }
  })], 1)]), _c('div', {
    staticClass: "row columns"
  }, [_c('label', [_vm._v("Description"), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.description),
      expression: "body.description"
    }],
    attrs: {
      "rows": "8"
    },
    domProps: {
      "value": (_vm.body.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "description", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "row columns"
  }, [_c('label', {
    attrs: {
      "aria-describedby": "documentsUpload"
    }
  }, [_c('dropzone', {
    attrs: {
      "id": "myVueDropzone",
      "url": _vm.dropzoneUrl
    },
    on: {
      "vdropzone-success": _vm.uploaded
    }
  })], 1)]), (_vm.damageReport) ? _c('div', {
    staticClass: "row columns"
  }, [(_vm.body.damage_position_raw) ? _c('vehicle-damage', {
    attrs: {
      "items": _vm.body.damage_position_raw,
      "editable": true,
      "vehicleDamagePicture": _vm.category.damage_picture_external,
      "vehicleType": _vm.vehicleType
    },
    on: {
      "damagesUpdated": _vm.updateDamages
    }
  }) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns text-center"
  }, [_c('label', [_c('input', {
    staticClass: "button expanded",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submit
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-386db7d6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CreateReporting.vue
// module id = 2408
// module chunks = 1